"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Head = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_helmet_1 = require("react-helmet");
const react_intl_1 = require("react-intl");
const notification_context_1 = require("@src/context/notification-context");
const localized_path_1 = require("@shared/localized-path");
const react_router_1 = require("react-router");
const Head = (props) => {
    const intl = (0, react_intl_1.useIntl)();
    const NotificationContext = (0, notification_context_1.useNotificationContextValue)();
    const location = (0, react_router_1.useLocation)();
    const locale = (0, localized_path_1.getLanguageFromPathname)(location.pathname);
    const { unseenNotificationsCount } = NotificationContext;
    const notificationsTitleString = unseenNotificationsCount > 0 ? `(${unseenNotificationsCount}) ` : '';
    const id = props.id || 'app';
    const defaultImage = locale === 'uk'
        ? `${process.env.PUBLIC_URL}/media/images/meta-homepage-uk.jpg`
        : `${process.env.PUBLIC_URL}/media/images/meta-homepage.jpg`;
    const imageUrl = props.imageUrl || defaultImage;
    const title = props.title
        ? `${notificationsTitleString}${props.title}`
        : `${notificationsTitleString}${intl.formatMessage({ id: `${id}.head.title` })}`;
    const titleSocial = props.customSocialTitle ? intl.formatMessage({ id: `${id}.head.title.social` }) : title;
    const description = props.description || intl.formatMessage({ id: `${id}.head.description` });
    const descriptionSocial = props.customSocialDescription
        ? intl.formatMessage({ id: `${id}.head.description.social` })
        : description;
    return ((0, jsx_runtime_1.jsxs)(react_helmet_1.Helmet, { children: [(0, jsx_runtime_1.jsx)("title", { children: title }), (0, jsx_runtime_1.jsx)("meta", { property: "og:title", content: titleSocial }), (0, jsx_runtime_1.jsx)("meta", { name: "description", content: description }), (0, jsx_runtime_1.jsx)("meta", { property: "og:description", content: descriptionSocial }), (0, jsx_runtime_1.jsx)("meta", { property: "og:type", content: "article" }), (0, jsx_runtime_1.jsx)("meta", { property: "og:image", content: imageUrl })] }));
};
exports.Head = Head;
